import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Dealer.Find.IRequest;
type Response = Api.Core.Dealer.Find.IResponse;
type Headers = Api.Core.Dealer.Find.IHeaders;
const url = '/api/DealerManagement/Dealer/:id';
export default async function dealerFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
